module.exports = __webpack_public_path__ + "img/72.1f5c83b1.svg";